import { participantsGatewayInterface } from '../../../corelogic/usecases/participants/participantsGatewayInterface';
import { EParticipant } from '../../../corelogic/models/entities/participant/participant';
import client from '../libs/client';
import { DsoDetails } from '../../../corelogic/models/entities/participant/dsoDetails';
import { BillableEntity } from '../../../corelogic/models/entities/billing-new/billableEntity';

export default class APIParticipantsGateway implements participantsGatewayInterface {
  error: any;

  getParticipantsByJwt = async (): Promise<EParticipant[]> => {
    const { data: participants } = await client.get('/participants/by-jwt');
    let newBillableEntity: BillableEntity;
    let newDsoDetails: DsoDetails;
    return participants.map((participant: any) => {
      if (participant.billableEntity) {
        newBillableEntity = new BillableEntity(
          participant.billableEntity.id,
          participant.billableEntity.name,
          participant.billableEntity.address,
          participant.billableEntity.postCode,
          participant.billableEntity.city,
          participant.billableEntity.phoneNumber,
          participant.billableEntity.email,
        );
      }
      newDsoDetails = new DsoDetails(
        participant.dsoDetails.prm,
        participant.dsoDetails.ean,
        participant.dsoDetails.city,
        participant.dsoDetails.postCode,
        participant.dsoDetails.address,
        participant.dsoDetails.name,
      );
      return new EParticipant(
        participant.id,
        participant.dsoDetails.name,
        participant.activationRange,
        participant.userId,
        participant.operationId,
        newDsoDetails,
        newBillableEntity,
      );
    });
  };

  async updateDsoDetails({
    dsoDetails,
    participantId,
  }: {
    dsoDetails: DsoDetails;
    participantId: number;
  }): Promise<DsoDetails> {
    const { data }: any = await client.put(`/participants/${participantId}`, { dsoDetails: dsoDetails.serialize() });
    return new DsoDetails(
      data.dsoDetails.prm,
      data.dsoDetails.ean,
      data.dsoDetails.city,
      data.dsoDetails.postCode,
      data.dsoDetails.address,
      data.dsoDetails.name,
    );
  }

  async updateBillableEntity({
    billableEntity,
    participantId,
  }: {
    billableEntity: BillableEntity;
    participantId: number;
  }): Promise<BillableEntity> {
    const { data }: any = await client.put(
      `/participants/${participantId}/billing/billable-entities/${billableEntity._id}`,
      billableEntity.serialize(),
    );
    return new BillableEntity(
      data.billableEntity.id,
      data.billableEntity.name,
      data.billableEntity.address,
      data.billableEntity.postCode,
      data.billableEntity.city,
      data.billableEntity.email,
      data.billableEntity.phoneNumber,
    );
  }
}
